import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { EJoinOtaStep } from 'shared/types/joinOtaIndividual/step';
import { getNextStep, getPrevStep } from '../../../utils/steps';
import { ELandingType } from '../../../types/landingType';
import { ILogger, TError } from '@cian/logger/shared';
import { TMeta } from '@cian/logger/shared/types';
import { acceptPublicOffer } from '../../../thunks/joinOtaIndividual/acceptPublicOffer';
import { saveFormAndAcceptOffer } from '../../../thunks/joinOtaIndividual/saveFormAndAcceptOffer';

type TPayload = ELandingType;

interface IErrorPayload {
  logger: ILogger;
  error: TError;
  extra?: TMeta;
}

export interface IStepsSlice {
  activeStep: EJoinOtaStep;
  steps: EJoinOtaStep[];
}

const initialState: IStepsSlice = {
  activeStep: EJoinOtaStep.Unexpected,
  steps: [EJoinOtaStep.Unexpected],
};

const stepsConfigurationSlice = createSlice({
  name: 'joinOtaIndividual/steps',
  initialState,
  reducers: {
    goToNextStep(state, action: PayloadAction<TPayload>) {
      state.activeStep = getNextStep(
        state.steps,
        EJoinOtaStep.Unexpected,
        action.payload,
        state.activeStep,
      ) as EJoinOtaStep;
    },
    goToPrevStep(state, action: PayloadAction<TPayload>) {
      state.activeStep = getPrevStep(
        state.steps,
        EJoinOtaStep.Unexpected,
        action.payload,
        state.activeStep,
      ) as EJoinOtaStep;
    },
    goToErrorStep: (state, action: PayloadAction<IErrorPayload>) => {
      const { logger, error, extra } = action.payload;
      logger.error(error, extra);

      state.activeStep = EJoinOtaStep.Error;
    },
  },
  extraReducers(builder) {
    builder.addCase(acceptPublicOffer.rejected, state => {
      state.activeStep = EJoinOtaStep.Error;
    });
    builder.addCase(saveFormAndAcceptOffer.rejected, state => {
      state.activeStep = EJoinOtaStep.Error;
    });
  },
});

export const {
  reducer: stepsConfigurationReducer,
  actions: { goToNextStep, goToPrevStep, goToErrorStep },
} = stepsConfigurationSlice;
